export enum FeatureRequestStatus {
  SUBMITTED = 'SUBMITTED',
  APPROVED = 'APPROVED',
  IN_PROGRESS = 'IN_PROGRESS',
  IMPLEMENTED = 'IMPLEMENTED',
  REJECTED = 'REJECTED',
}

export enum FeatureRequestPriority {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  CRITICAL = 'CRITICAL',
}

export interface FeatureRequestAttachment {
  id: string;
  filename: string;
  contentType: string;
  size: number;
}

export interface FeatureRequest {
  id: string;
  summary: string;
  description: string;
  status: FeatureRequestStatus;
  priority: FeatureRequestPriority;
  projectUrn: string;
  componentUrn: string | null;
  requesterRef: string;
  attachments: FeatureRequestAttachment[];
  createdAt: string;
  updatedAt: string;
}

export interface FeatureRequestListItem {
  id: string;
  summary: string;
  status: FeatureRequestStatus;
  priority: FeatureRequestPriority;
  projectUrn: string;
  componentUrn: string | null;
  requesterRef: string;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedResponse<T> {
  items: T[];
  total: number;
  offset: number;
  limit: number;
}

export interface FeatureRequestFilters {
  componentUrn?: string;
  status?: FeatureRequestStatus;
  priority?: FeatureRequestPriority;
  offset: number;
  limit: number;
}

export interface RequesterFeatureRequestFilters {
  projectUrn?: string;
  status?: FeatureRequestStatus;
  priority?: FeatureRequestPriority;
  offset: number;
  limit: number;
}

export interface ReceivedFeatureRequestFilters {
  projectUrn?: string;
  status?: FeatureRequestStatus;
  priority?: FeatureRequestPriority;
  offset: number;
  limit: number;
}

export enum FeatureRequestView {
  MY = 'MY',
  RECEIVED = 'RECEIVED',
}
